import Vue from 'vue'
import {getFilePath} from "@/api/jurisdiction";
import {Toast} from "vant";

const state = {

}
const mutations = {
        /**
         * 为state项赋值
         * @param state
         * @param data
         */
        setStateItem(state, data) {
                state[data.key] = data.value
        },

}
const actions = {
        /**
         * 获取文件全路径
         */
        async getFilePath({ state,commit },data){
                try {
                        const res = await getFilePath(data)
                        if (res.data.code==200) {
                                data.cb(res.data.data)
                                return res.data.data
                        } else {
                                Toast(res.data.message)
                                return false
                        }
                } catch (e) {
                        return false
                }
        },
}
export default {
        state,
        actions,
        mutations,
        namespaced: true,
}
